// extracted by mini-css-extract-plugin
module.exports = {"skeletonHeader":"SkeletonApplicationHeaderPreview_skeletonHeader__yG4J-","skeletonTitle":"SkeletonApplicationHeaderPreview_skeletonTitle__3YmvA"};